import helpers from '@/Mixins/helpers'

const getters = {
    token: (state) => state.auth.token,
    isRefreshing: (state) => state.auth.isRefreshing,
    tokenExpired: (state) =>
        state.auth.token ? Date.now() >= helpers.methods.parseJwt(state.auth.token).exp * 1000 : false,
    user: (state) => state.auth.user,
}

export default getters
